import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from 'src/design/atoms/Box';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { accountItems, mainItems } from 'src/app/navigation/navigationDataMain';
import { jobItems } from 'src/app/navigation/navigationDataJobs';
import { settingsItems } from 'src/app/navigation/navigationDataSettings';
import { INavigationMenu } from 'src/app/navigation/navigationTypes';
import { NavGroup } from 'src/app/navigation/NavGroup';

/** @registry Sidebar navigation tree: picks the active menu (main/job/account/settings) by route and renders its groups. */
export const Navigation = React.memo(function Navigation() {
  const { pathname } = useLocation();

  const menuItems = React.useMemo<INavigationMenu>(() => {
    if (pathname.includes('/settings')) return settingsItems;
    if (pathname.includes('/jobs/') && pathname.length > 6) return jobItems;
    if (pathname.includes('/account/')) return accountItems;
    return mainItems;
  }, [pathname]);

  const navGroups = menuItems.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Text key={item.id} c="red" ta="center" fw={600}>
            Fix - Navigation Group
          </Text>
        );
    }
  });

  return (
    <Box pt="md">
      <Stack gap={0}>{navGroups}</Stack>
    </Box>
  );
});
